import React, { FormEvent, useContext, useState } from "react";
import { MdOutlineReceipt } from "react-icons/md";
import { Button, Form } from "react-bootstrap";
import package_json from "./../../../package.json";

import { Container, Logo } from "./styles";
import { AuthContext } from "../../Shared/AuthContext";

const Login: React.FC = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const { signIn } = useContext(AuthContext);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    await signIn({ user, password });
  };

  return (
    <Container>
      <div>
        <span style={{ color: "white" }}>Versão {package_json.version}</span>
      </div>
      <Logo>
        <MdOutlineReceipt color="#FB8500" size={90} />
      </Logo>
      <Form onSubmit={handleSubmit}>
        <Form.Group style={{ marginBottom: "1rem" }}>
          <Form.Label style={{ color: "white" }}>Usuário</Form.Label>
          <Form.Control
            type="text"
            placeholder="Usuário"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setUser(e.target.value)
            }
            value={user}
            name="user"
          />
          <Form.Label style={{ color: "white", marginTop: "1rem" }}>
            Senha
          </Form.Label>
          <Form.Control
            type="password"
            placeholder="Senha"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPassword(e.target.value)
            }
            value={password}
            name="password"
          />
        </Form.Group>
        <Button variant="primary" type="submit">
          Entrar
        </Button>
      </Form>
    </Container>
  );
};

export default Login;
